import React, { Component } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { string } from 'prop-types'

import { countries } from 'utils'

@observer
class Flag extends Component {
  render() {
    const { code, className, ...rest } = this.props
    const cdn = 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.8.0/flags/4x3/'
    const COUNTRY = countries.byValue(code.toUpperCase())
    if (!COUNTRY?.ALPHA_2) return null
    return (
      <div title={COUNTRY.NAME} className={`flag-component ${className}`} {...rest}>
        <div className={`flag-item`} style={{ backgroundImage: `url('${cdn}${COUNTRY.ALPHA_2.toLowerCase()}.svg')` }} />
      </div>
    )
  }
}

Flag.propTypes = {
  code: string.isRequired,
}

Flag.defaultProps = {}

Flag.displayName = 'Flag'

export default Flag
